import { ITokenUser } from "../models/token-user";
import CookieHelper from "./cookieHelper";
import jwt_decode from "jwt-decode";
import { CommonConstants } from "../constants/common-constants";
import { IFoundationProgram } from "../models/foundationProgram";
import { IOlympiadExam } from "../models/olympiadExam";
import { OlympiadExamConstants } from "../data/olympiadExams";
import { FoundationProgramConstants } from "../data/foundationPrograms";

import { camelCase, isPlainObject } from 'lodash';
import { IVideoLessionProgram } from "../models/videoLessionProgram";
import { VideoLessionPrograms } from "../data/videoLessionPrograms";
const camelizeKeys = <
  T extends Record<string, unknown> | Record<string, unknown>[]
>(
  obj: T
): T => {
  if (Array.isArray(obj)) {
    return <T>obj.map((v) => camelizeKeys(v));
  } else if (isPlainObject(obj)) {
    return <T>Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [camelCase(key)]: camelizeKeys(<T>obj[key]),
      }),
      {}
    );
  }
  return obj;
};

const key = CommonConstants.UserTokenKey;
const Save = (token: string): void => {
  CookieHelper.save(key, token);
};

const Get = (): ITokenUser => {
  let tokenUser: ITokenUser;
  try {
    const value: string = CookieHelper.get(key);
    tokenUser = jwt_decode(value);
    return tokenUser;
  } catch {
    return {} as ITokenUser;
  }
};

const GetFoundationPrograms = () : IFoundationProgram[] =>{
  const tokenUser = Get();
  if(tokenUser && tokenUser.UserType === CommonConstants.UserType.Admin){
    return FoundationProgramConstants;
  }
  if(tokenUser && tokenUser.FoundationPrograms && tokenUser.FoundationPrograms.length > 0){
    const obj :IFoundationProgram[]  = camelizeKeys(JSON.parse(tokenUser.FoundationPrograms));
    return obj;
  }
  return [];
}

const GetOlympiadExams = () : IOlympiadExam[] =>{
  const tokenUser = Get();
  if(tokenUser && tokenUser.UserType === CommonConstants.UserType.Admin){
    return OlympiadExamConstants;
  }
  if(tokenUser && tokenUser.OlympiadExams && tokenUser.OlympiadExams.length > 0){
    const obj :IOlympiadExam[]  = camelizeKeys(JSON.parse(tokenUser.OlympiadExams));
    return obj;
  }
  return [];
}

const GetVideoLessionPrograms = () : IVideoLessionProgram[] =>{
  const tokenUser = Get();
  if(tokenUser && tokenUser.UserType === CommonConstants.UserType.Admin){
    return VideoLessionPrograms;
  }
  if(tokenUser && tokenUser.VideoLessionPrograms && tokenUser.VideoLessionPrograms.length > 0){
    const obj :IVideoLessionProgram[]  = camelizeKeys(JSON.parse(tokenUser.VideoLessionPrograms));
    return obj;
  }
  return [];
}
const Delete = (): void => {
  CookieHelper.remove(key);
};

export const TokenUserHelper = {
  Save,
  Get,
  GetFoundationPrograms,
  GetOlympiadExams,
  GetVideoLessionPrograms,
  Delete,
};
